import { type ComponentType } from "react";

import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import TwoWheelerIcon from "@mui/icons-material/TwoWheeler";
import { SvgIconProps } from "@mui/material";

import CaravanIcon from "@/src/components/atoms/CaravanIcon";

import { VehicleType } from "@/src/types/types";

export const VEHICLE_TYPE_ICONS = {
  [VehicleType.CAR]: DirectionsCarIcon,
  [VehicleType.MOTO]: TwoWheelerIcon,
  [VehicleType.CARAVAN]: CaravanIcon
} as Record<VehicleType, ComponentType<SvgIconProps>>;

export const VEHICLE_TYPE_TEST_IDS: Record<VehicleType, string> = {
  [VehicleType.CAR]: "consumer-home-car-btn",
  [VehicleType.MOTO]: "consumer-home-moto-btn",
  [VehicleType.CARAVAN]: "consumer-home-caravan-btn"
};

/** Home page vehicle tab row height (px) on desktop/tablet (sm+). */
export const HOME_PAGE_VEHICLE_SELECTOR_ROW_HEIGHT_PX = 62;

/** Home page vehicle tab row height (px) on mobile (xs). */
export const HOME_PAGE_VEHICLE_SELECTOR_ROW_HEIGHT_MOBILE_PX = 60;
